module.exports = __webpack_public_path__ + "img/image_9.ed5438a1.png";